import Link from 'next/link'

import { Button } from '@/components/ui/button'
import { env } from '@/env'

export const BookerSuccessFooterCta = () => {
  return (
    <div className="flex flex-col items-center p-2 text-center">
      <div className="h6 mb-1">
        Schedule your own meetings with Fingertip for free
      </div>

      <div className="text-sm text-muted-foreground mb-2">
        Eliminate the back-and-forth emails for finding time.
      </div>

      <Button variant="secondary" size="sm" asChild>
        <Link href={`${env.NEXT_PUBLIC_SITE_URL}/onboarding`}>Sign up</Link>
      </Button>
    </div>
  )
}
